import { ScreenType } from '../../config/FlowTypes';
import { WorksBestScreen } from '../trial/WorksBestScreen';
import { AiLoadingScreen } from './AiLoadingScreen';
import { AuthScreen } from './AuthScreen';
import { ClassifyScreen } from './ClassifyScreen';
import { DateOfBirthScreen } from './DateOfBirthScreen';
import { DownloadAppScreen } from './DownloadAppScreen';
import { DropdownSelectScreen } from './DropdownSelectScreen';
import { ExpectationSettingScreen } from './ExpectationSettingScreen';
import { ExternalLinkScreen } from './ExternalLinkScreen';
import { FinishAccountScreen } from './FinishAccountScreen';
import { HcpReferredScreen } from './HcpReferredScreen';
import { HypnotisabilityResultsScreen } from './HypnotisabilityResultsScreen';
import { InsuranceProviderScreen } from './InsuranceProviderScreen';
import { LoadingResultsScreen } from './LoadingResultsScreen';
import { MoneyBackGuaranteeScreen } from './MoneyBackGuaranteeScreen';
import { MultiSelectScreen } from './MultiSelectScreen';
import { NumberedSingleSelectScreen } from './NumberedSingleSelectScreen';
import { PaymentScreen } from './PaymentScreen';
import { PhoneNumberScreen } from './PhoneNumberScreen';
import { PresentationScreen } from './PresentationScreen';
import { ProgramBenefitsScreen } from './ProgramBenefitsScreen';
import { ProgramExperienceScreen } from './ProgramExperienceScreen';
import { ProgramOverviewScreen } from './ProgramOverviewScreen';
import { ProgramStructureScreen } from './ProgramStructureScreen';
import { ReferralScreen } from './ReferralScreen';
import { ResultsScreen } from './ResultsScreen';
import { ScreenshotScreen } from './ScreenshotScreen';
import { ShareLinkScreen } from './ShareLinkScreen';
import { SingleInputScreen } from './SingleInputScreen';
import { SingleSelectScreen } from './SingleSelectScreen';
import { SocialProofScreen } from './SocialProofScreen';
import { TrialExplanationScreen } from './TrialExplanationScreen';
import { UserInfoRecapScreen } from './UserInfoRecapScreen';
import { CoverageAddressScreen } from './coverage/CoverageAddressScreen';
import { CoverageConsentsScreen } from './coverage/CoverageConsentsScreen';
import { CoverageEmployerScreen } from './coverage/CoverageEmployerScreen';
import { CoverageResultsScreen } from './coverage/CoverageResultsScreen';
import { PartnerInsurerAccessScreen } from './coverage/PartnerInsurerAccessScreen';
import { MedicareAccessCoverageLoadingScreen } from './medicareAccess/MedicareAccessCoverageLoadingScreen';
import { MedicareAccessHelplinesScreen } from './medicareAccess/MedicareAccessHelplines';
import { MedicareAccessMbiScreen } from './medicareAccess/MedicareAccessMbiScreen';
import { MedicareAccessSafetyCheckScreen } from './medicareAccess/MedicareAccessSafetyCheckScreen';
import { PapDiscountResultScreen } from './patientAssistance/PapDiscountResultScreen';
import { PapHouseholdIncomeScreen } from './patientAssistance/PapHouseholdIncomeScreen';
import { PapPublicAssistanceScreen } from './patientAssistance/PapPublicAssistanceScreen';
import { Us65PlusGrantAccessScreen } from './us65Plus/Us65PlusGrantAccessScreen';

/** All screen types mapped to their components */
export const CONFIGURABLE_SCREENS = {
  [ScreenType.Auth]: AuthScreen,
  [ScreenType.Classify]: ClassifyScreen,
  [ScreenType.DownloadApp]: DownloadAppScreen,
  [ScreenType.FinishAccount]: FinishAccountScreen,
  [ScreenType.LoadingResults]: LoadingResultsScreen,
  [ScreenType.MoneyBackGuarantee]: MoneyBackGuaranteeScreen,
  [ScreenType.MultiSelect]: MultiSelectScreen,
  [ScreenType.Payment]: PaymentScreen,
  [ScreenType.PhoneNumber]: PhoneNumberScreen,
  [ScreenType.Presentation]: PresentationScreen,
  [ScreenType.ProgramBenefits]: ProgramBenefitsScreen,
  [ScreenType.ProgramExperience]: ProgramExperienceScreen,
  [ScreenType.ProgramOverview]: ProgramOverviewScreen,
  [ScreenType.ProgramStructure]: ProgramStructureScreen,
  [ScreenType.Referral]: ReferralScreen,
  [ScreenType.Results]: ResultsScreen,
  [ScreenType.Screenshot]: ScreenshotScreen,
  [ScreenType.SingleInput]: SingleInputScreen,
  [ScreenType.SingleSelect]: SingleSelectScreen,
  [ScreenType.SocialProof]: SocialProofScreen,
  [ScreenType.TrialExplanation]: TrialExplanationScreen,
  [ScreenType.UserInfoRecap]: UserInfoRecapScreen,
  [ScreenType.WorksBest]: WorksBestScreen,
  [ScreenType.HypnotisabilityResults]: HypnotisabilityResultsScreen,
  [ScreenType.InsuranceProvider]: InsuranceProviderScreen,
  [ScreenType.ShareLink]: ShareLinkScreen,
  [ScreenType.ExternalLink]: ExternalLinkScreen,
  [ScreenType.DateOfBirth]: DateOfBirthScreen,
  [ScreenType.HcpReferred]: HcpReferredScreen,
  [ScreenType.AiLoading]: AiLoadingScreen,
  [ScreenType.PapPublicAssistance]: PapPublicAssistanceScreen,
  [ScreenType.PapHouseholdIncome]: PapHouseholdIncomeScreen,
  [ScreenType.PapDiscountResult]: PapDiscountResultScreen,
  [ScreenType.MedicareAccessHelplines]: MedicareAccessHelplinesScreen,
  [ScreenType.MedicareAccessMbi]: MedicareAccessMbiScreen,
  [ScreenType.MedicareAccessCoverageLoading]: MedicareAccessCoverageLoadingScreen,
  [ScreenType.MedicareAccessSafetyCheck]: MedicareAccessSafetyCheckScreen,
  [ScreenType.Us65PlusGrantAccess]: Us65PlusGrantAccessScreen,
  [ScreenType.NumberedSingleSelect]: NumberedSingleSelectScreen,
  [ScreenType.ExpectationSetting]: ExpectationSettingScreen,
  [ScreenType.CoverageEmployer]: CoverageEmployerScreen,
  [ScreenType.CoverageAddress]: CoverageAddressScreen,
  [ScreenType.CoverageResults]: CoverageResultsScreen,
  [ScreenType.DropdownSelect]: DropdownSelectScreen,
  [ScreenType.PartnerInsurerAccess]: PartnerInsurerAccessScreen,
  [ScreenType.CoverageConsents]: CoverageConsentsScreen,
};
